import src from "IMAGE";
export default { src, width: 700, height: 700, blurWidth: 0, blurHeight: 0};
